import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Figure Icon
 *
 * @file Figure.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Figure = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 14V9.75C2 9.33579 2.33579
        9 2.75 9H6V5.75C6 5.33579 6.33579 5 6.75 5H10V2.75C10 2.33579 10.3358 2
        10.75 2H15.25C15.6642 2 16 2.33579 16 2.75V14H17C17.5523 14 18 14.4477
        18 15C18 15.5523 17.5523 16 17 16H1C0.447715 16 0 15.5523 0 15C0 14.4477
        0.447715 14 1 14H2ZM3.75 10.75V14.25H6.25V10.75H3.75ZM7.75
        6.75V14.25H10.25V6.75H7.75ZM11.75 3.75V14.25H14.25V3.75H11.75Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Figure;
